import { Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import EmailProcessingSection from '../features/dashboard/sections/EmailProcessingSection';
import MailboxesProcessingSection from '../features/dashboard/sections/MailboxesProcessingSection';
import MailboxCardsSection from '../features/dashboard/sections/MailboxCardsSection';

const DashboardPage = () => {

    return (
        <Stack gap={5}>
            <EmailProcessingSection />
            {/* <MailboxesProcessingSection /> */}
            <MailboxCardsSection />
        </Stack>
    )
}

export default DashboardPage;